import { LangCodes } from '../types';

export const detectLanguage = () => {
    const { hostname, pathname } = window.location;

    if (hostname.endsWith('.us') || pathname.startsWith('/en-us')) {
        return LangCodes.US;
    }

    return LangCodes.GB;
};
